// extracted by mini-css-extract-plugin
export var banner = "_14-0";
export var icon = "_14-1";
export var message = "_14-2";